import { IEnvironment } from "./environment";

export const devEnv: IEnvironment = {
  env: "development",
  api: {
    protocol: "https",
    host: "dev.api.aurora.codebehind.tech",
  },
  oidc: {
    clientId: "240728055608311810@auroradms",
    issuerEndpoint: "https://dev.auth.aurora.codebehind.tech",
    loginCallbackUrl: "https://dev.aurora.codebehind.tech/code",
    authorizationEndpoint: "https://dev.auth.aurora.codebehind.tech/oauth/v2/authorize",
    scope: "openid profile email urn:zitadel:iam:user:metadata",
    keyListEndpoint: "https://dev.auth.aurora.codebehind.tech/oauth/v2/keys",
    userInfoEndpoint: "https://dev.auth.aurora.codebehind.tech/oidc/v1/userinfo",
    roleFieldName: "urn:zitadel:iam:org:project:240702449919197186:roles",
    endSessionEndpoint: "https://dev.auth.aurora.codebehind.tech/oidc/v1/end_session",
  },
  modulesEnabled: {
    archive: true,
    digitalSignature: true,
    qualifiedDigitalSignature: true,
    tasks: true,
    sefProvider: true,
    emailListenerProvider: true,
    networkShareProvider: true,
    ocr: true,
  },
  documentTableColumns: {
    userName: false,
    description: true,
    creationDate: true,
    archiveDate: false,
    documentType: true,
    documentStatus: true,
    tags: true,
  },
};
